import React, { useState } from 'react'
import { ArrowUpOutlined } from '@ant-design/icons'
import { Button, Input } from 'antd'
import style from './chat-bar.module.sass'
import { useLlm } from './useLlm'

const { TextArea } = Input

const PREFILL_OPTIONS = [
	"Let's get started",
	'What are my priority actions?',
	"What's already been done?",
]

export const ChatBar = ({
	awaitingResponse,
	send,
	hasMessages,
}: Pick<ReturnType<typeof useLlm>, 'awaitingResponse' | 'send'> & { hasMessages: boolean }) => {
	const [inputValue, setInputValue] = useState('')

	const onSend = (content = inputValue) => {
		send({ content })
		setInputValue('')
	}

	const handleKeyPress = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault()
			if (!awaitingResponse) onSend()
		}
	}
	return (
		<div>
			{!hasMessages && (
				<div className={style.prefillPills}>
					{PREFILL_OPTIONS.map((option) => (
						<button
							key={option}
							className={style.prefillPill}
							onClick={() => onSend(option)}
							disabled={awaitingResponse}
						>
							{option}
						</button>
					))}
				</div>
			)}
		<div className={style.inputContainer}>
			<TextArea
				value={inputValue}
				onChange={(e) => setInputValue(e.target.value)}
				onKeyPress={handleKeyPress}
				placeholder="Ask me anything about this form..."
				autoSize={{ minRows: 1, maxRows: 30 }}
				className={style.messageInput}
				autoFocus={true}
			/>
			<Button
				type="primary"
				icon={<ArrowUpOutlined />}
				onClick={() => onSend()}
				disabled={!inputValue.trim() || awaitingResponse}
				className={style.sendButton}
				size="small"
			/>
		</div>
		</div>
	)
}
